module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/159.5c23b242.png";